import { render, staticRenderFns } from "./sleep-event.vue?vue&type=template&id=0ffbe3c2&scoped=true"
import script from "./sleep-event.vue?vue&type=script&lang=js"
export * from "./sleep-event.vue?vue&type=script&lang=js"
import style0 from "./sleep-event.vue?vue&type=style&index=0&id=0ffbe3c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ffbe3c2",
  null
  
)

export default component.exports